// @flow

import isNull from 'lodash/isNull'
import ApiError from 'PMT/entities/ApiError'
import CartModifier from 'PMT/entities/menu/CartModifier'
import ReduceStore from 'PMT/flux/ReduceStore'
import RoutingEnum from 'constants/RoutingEnum'
import RouteStore from './RouteStore'

import ActionTypes from 'constants/ActionTypes'

class CartModifierStore extends ReduceStore {

  getInitialState() {
    return {
      data: new CartModifier(),
      apiError: null,
      isFetching: false,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      data: {},
      isFetching: false,
    }
  }

  getState() {
    return this._state
  }

  reduce(state, action, nextState) {
    switch(action.type) {
      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState()

      case ActionTypes.GET_CART_MODIFIER:
        nextState.isFetching = true
        nextState.apiError = null
        nextState.data = null
        return nextState

      case ActionTypes.GET_CART_MODIFIER_SUCCESS:
        nextState.isFetching = false
        nextState.apiError = null
        nextState.data = action.data
        return nextState

      case ActionTypes.GET_CART_MODIFIER_FAILURE:
        nextState.isFetching = false
        nextState.data = null
        nextState.apiError = action.apiError
        return nextState

      case ActionTypes.POST_CART_MODIFIER:
        nextState.isFetching = true
        return nextState

      case ActionTypes.POST_CART_MODIFIER_SUCCESS:
       RouteStore.redirectTo(RoutingEnum.ORDERS_CART_MODIFIERS_LIST)
        // TODO: uncomment and debug when creating a new cart modifier
        // RouteStore.redirectTo(RoutingEnum.ORDERS_CART_MODIFIERS_EDIT, { cartModifierId: action.data.id })
        return nextState

      case ActionTypes.PUT_CART_MODIFIER:
        nextState.isFetching = true
        return nextState

      case ActionTypes.PUT_CART_MODIFIER_SUCCESS:
        if (!isNull(nextState.data) && nextState.data.id === action.data.id) {
          nextState.isFetching = false
          nextState.data = action.data
        }
        return nextState


      default:
        return nextState
    }
  }

}

export default new CartModifierStore()



// WEBPACK FOOTER //
// ./scripts/stores/CartModifierStore.js